
import { defineComponent, SetupContext, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import FavoriteButton from '@/components/elements/FavoriteButton.vue'
import HospitalLabel from '@/components/elements/HospitalLabel.vue'
import TableDefinition, {
  Definition
} from '@/components/elements/TableDefinition.vue'
import HospitalTag from '@/components/elements/HospitalTag.vue'
import { ActionHistory } from '@/types/StoreState'
import { numberFormatAddComma } from '@/utils/commonMethods'

export default defineComponent({
  name: 'HospitalCassetteSeminar',

  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    enableRequest: {
      type: Boolean,
      default: false
    },
    isShowRequestBtn: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Button,
    FavoriteButton,
    HospitalLabel,
    HospitalTag,
    TableDefinition
  },

  setup(props, context: SetupContext) {
    const store = useStore()
    const data = reactive({
      labels: props.detail.program_subjects,
      features: props.detail.feature_tag
        ? props.detail.feature_tag.map((el: string) => {
            return {
              label: el,
              disabled: false
            }
          })
        : []
    })

    const aboutTableData = computed((): Definition[] => {
      return [
        {
          dt: '当科病床数',
          dd:
            props.detail.department_bed_num !== null
              ? `${numberFormatAddComma(props.detail.department_bed_num)}`
              : 0,
          unit: '床'
        },
        {
          dt: '研修医数',
          dd: props.detail.resident_num ?? 0,
          unit: '人'
        },
        {
          dt: '当科指導医数',
          dd: props.detail.instructor_num ?? 0,
          unit: '人'
        },
        {
          dt: '募集人数',
          dd: props.detail.recruitment_num ?? 0,
          unit: '人'
        }
      ]
    })

    // お気に入り判定
    const isFavorite = computed(() => {
      if (!store.state.isLogin) return false

      return store.state.userInfo.s_favorite_history.some(
        (el: ActionHistory) => el.s_training_id == props.detail.s_training_id
      )
    })

    const clickFavBtn = () => {
      if (isFavorite.value) {
        store.dispatch('removeFavorite', {
          id: props.detail.hospital_id,
          sId: props.detail.s_training_id
        })
      } else {
        store.dispatch('addFavorite', {
          id: props.detail.hospital_id,
          sId: props.detail.s_training_id
        })
      }
    }

    const favBtnLabel = computed(() => {
      return isFavorite.value ? 'お気に入り登録済み' : 'お気に入りに保存'
    })

    const aboutText = computed(() => {
      const text = props.detail.overview_list || ''
      return text?.length > 77 ? text.substring(0, 76) + '…' : text
    })

    const canRequestCheck = computed(() => {
      if (
        props.enableRequest &&
        props.detail.paid_flg === 1 &&
        props.detail.active_flg === 3
      ) {
        return true
      } else {
        return false
      }
    })

    const changeInput = (e: any) => {
      context.emit('call-input-change', {
        value: e.target.value,
        checked: e.target.checked
      })
    }

    return {
      data,
      isFavorite,
      clickFavBtn,
      favBtnLabel,
      canRequestCheck,
      aboutText,
      changeInput,
      aboutTableData
    }
  }
})
